/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Directory_Ai_Tools_Studio_Sticky_MetaInputs */

const en_directory_ai_tools_studio_sticky_meta = /** @type {(inputs: Directory_Ai_Tools_Studio_Sticky_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.credits} credits · failed renders refunded`)
};

const zh_directory_ai_tools_studio_sticky_meta = /** @type {(inputs: Directory_Ai_Tools_Studio_Sticky_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.credits} 积分 · 失败自动退还`)
};

/**
* | output |
* | --- |
* | "{credits} credits · failed renders refunded" |
*
* @param {Directory_Ai_Tools_Studio_Sticky_MetaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_sticky_meta = /** @type {((inputs: Directory_Ai_Tools_Studio_Sticky_MetaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Sticky_MetaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_sticky_meta(inputs)
	return zh_directory_ai_tools_studio_sticky_meta(inputs)
});
export { directory_ai_tools_studio_sticky_meta as "directory.ai_tools.studio.sticky_meta" }